exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".empty-content .content-text{text-align:center;color:#99a9bf;padding:100px 0}", "", {"version":3,"sources":["D:/project/atlanta-git-clone/src/static/style/common/D:\\project\\atlanta-git-clone/src\\static\\style\\common\\emptycontent.scss"],"names":[],"mappings":"AAAA,6BAEQ,kBAAiB,AACjB,cAAc,AACd,eAAgB,CACnB","file":"emptycontent.scss","sourcesContent":[".empty-content {\r\n    .content-text {\r\n        text-align:center;\r\n        color: #99A9BF;\r\n        padding: 100px 0;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/static/style/common/emptycontent.scss
// module id = 285
// module chunks = 0 10